import Head from "next/head";
import { useMemo } from "react";

const BASE_URL = process.env.NEXT_PUBLIC_BASE_URL;
const SITE_NAME = process.env.NEXT_PUBLIC_SITE_NAME;
const SITE_DESCRIPTION = process.env.NEXT_PUBLIC_SITE_DESCRIPTION;
// const TWITTER_HANDLE = process.env.NEXT_PUBLIC_TWITTER_HANDLE;
const PUBLIC_LOGO = process.env.NEXT_PUBLIC_LOGO;

export const defaultProps = {
  siteName: SITE_NAME,
  title: SITE_NAME,
  titleTemplate: `%s | ${SITE_NAME}`,
  defaultTitle: SITE_NAME,
  description: SITE_DESCRIPTION,
  images: [
    {
      url: PUBLIC_LOGO,
    },
  ],
  // twitter: {
  //   site: TWITTER_HANDLE,
  //   cardType: "summary_large_image",
  // },
};

export default function ({
  title,
  robots,
  image,
  keywords,
  alternate = { url: "", hreflang: "" },
  canonical: __canonical = "",
  description,
  json_schema,
}) {
  const resolvedTitle = (title || SITE_NAME || "").trim();
  const resolvedDescription = (description || SITE_DESCRIPTION || "").trim();
  const resolvedImage = (image || PUBLIC_LOGO);
  const canonical = useMemo(() => {
    let url = __canonical.startsWith("http") ? __canonical : `${BASE_URL}${__canonical}`;
    return !url.endsWith("/") ? `${url}` : url;
  }, [__canonical]);

  const languageAlternates = useMemo(() => {
    if (alternate?.hreflang && alternate?.hreflang) {
      return [{ hrefLang: alternate.hreflang, href: alternate.url }];
    }
    return [];
  }, []);

  return (
    <>
      <Head>
        <title>{resolvedTitle}</title>
        <meta name="description" content={resolvedDescription} />
        {robots ? <meta name="robots" content={robots} /> : null}
        {keywords ? <meta name="keywords" content={keywords} /> : null}
        <meta property="og:title" content={resolvedTitle} />
        <meta property="og:description" content={resolvedDescription} />
        <meta property="og:image" content={resolvedImage} />
        <meta property="og:url" content={canonical} />
        <link rel="canonical" href={canonical} />
        {languageAlternates.map((item) => (
          <link
            key={`${item.hrefLang}-${item.href}`}
            rel="alternate"
            hrefLang={item.hrefLang}
            href={item.href}
          />
        ))}
      </Head>
      {json_schema && (
        <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: json_schema }} />
      )}
    </>
  );
}
